<template>
  <div class="home_wrap">
    <el-dialog title="报价单"
      append-to-body
      :visible.sync="isGenerateQuotationImg"
      v-loading="showLoading"
      :close-on-click-modal="false"
      width="960px"
      :before-close="handleClose">
      <canvas id="shareCanvas" class="share_canvas" width="910" :height="canvasHeight"></canvas>
      <img id="shareHeader" class="canvas_img logo" :src="storeInfo.storeLogo">
      <img id="code" class="canvas_img" :src="images.code">
      <!--使用星星图标  必须是矢量值-->
      <i id="star" class="canvas_img">
        &#xf005;
      </i>
      <div class="text-r footer_wrap m-r-20">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="createCanvas">保存报价</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CODE_IMG } from '@/config/constant.js'
import dayjs from 'dayjs'
export default {
  props: {
    isGenerateQuotationImg: {
      type: Boolean,
      default: false,
    },
    imgData: { // 图片数据
      isRequired: true,
      type: Array
    },
    storeInfo: {
      type: Object,
      default: () => {}
    },
    // 联系方式
    contactList: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      show: true,
      images: {
        code: CODE_IMG,
      },
      showLoading: false,
      canvasData: {}, // 画布数据
      canvasWidth: '', // 画布宽度
      canvasHeight: '', // 画布高度
    }
  },
  async mounted () {
    this.showLoading = true
    this.canvasData = this.imgData
    this.canvasHeight = 280 + (this.canvasData.length + 1) * 48 + (this.contactList.length / 2) * 30// 根据数据算出画布高度
    setTimeout(() => {
      this.draw() // 延时0.5s渲染画布，确保画布的数据和dom节点已准备完毕
    }, 500)
  },
  methods: {
    draw () {
      const canvas = document.getElementById('shareCanvas')
      const context = canvas.getContext('2d')
      // 绘制底部背景
      context.beginPath()
      // 渐变色
      // let grd = context.createLinearGradient(0, 0, 170, 0)
      // grd.addColorStop(0, 'white')
      // grd.addColorStop(1, '#ffcb62')
      context.fillStyle = '#ffffff'
      context.fillRect(0, 0, 910, 112)
      context.closePath()

      // 头部背景图
      let logoImg = new Image()
      // 增加这一行--解决跨域问题
      // logoImg.setAttribute('crossOrigin', 'anonymous')
      logoImg.crossOrigin = 'Anonymous'
      logoImg.src = this.storeInfo.storeLogo + '?v=' + Math.random() // 加上一个随机数  解决跨域报错问题
      logoImg.onload = function () {
        context.drawImage(logoImg, 20, 20, 72, 72)
      }

      // 头部报价信息
      context.fillStyle = '#333333' // 文字颜色
      context.fill()
      context.font = 'bold 20px Arial' // 文字字号
      const date = dayjs(new Date()).format('YYYY-MM-DD')
      context.fillText(this.storeInfo.storeName, 112, 48) // 绘制文字
      // 绘制星星
      let star = document.getElementById('star').textContent
      // this.drawStar(context)
      context.fillStyle = '#ffc804'
      context.font = 'normal 20px FontAwesome'
      context.fillText(star, 80, 87)
      context.fillText(star, 113, 87)
      context.fillText(star, 146, 87)
      context.fillText(star, 179, 87)
      context.fillText(star, 212, 87)
      context.fillText('5.0', 280, 87)
      context.textAlign = 'center'
      context.font = 'normal 16px Arial' // 文字字号
      context.fillStyle = '#333333' // 文字颜色
      context.fillText(`时间: ${date}`, 820, 70) // 绘制文字
      context.fillText(`时间: ${date}`, 820, 70) // 绘制文字
      context.save()

      // 报价表格的外层背景长方形
      const num = this.canvasData.length // 报价个数
      // 绘制表格边框
      context.beginPath()
      context.strokeStyle = '#dcdcdc'
      context.lineWidth = 0.5
      context.rect(0, 122, 910, (num + 1) * 48 + 1)
      context.fillStyle = 'white'
      context.fill()
      context.closePath()
      context.stroke()
      // 绘制表格斑马纹，偶数的行数背景为灰色
      // for (let n = 0; n < num; n = n + 2) {
      //   context.beginPath()
      //   context.rect(0, 171 + n * 40, 910, 40)
      //   context.fillStyle = '#f5f9fc'
      //   context.fill()
      //   context.closePath()
      // }
      context.beginPath()
      context.rect(0, 122, 910, 48)
      context.fillStyle = '#f9f9fa'
      context.fill()
      context.closePath()
      // 绘制表格分隔线
      for (let n = 0; n < num; n = n + 1) {
        context.beginPath()
        context.lineWidth = 0.5
        context.fillStyle = '#dcdcdc'
        context.moveTo(0, 171 + n * 48)
        context.lineTo(910, 171 + n * 48)
        context.stroke()
      }
      // 绘制表头
      context.fillStyle = '#333333' // 文字颜色
      context.font = 'bold 14px Arial' // 文字字号
      context.textAlign = 'left'

      context.fillText('品种', 20, 153) // 绘制文字
      context.fillText('品牌', 120, 153) // 绘制文字
      context.fillText('报价次数', 220, 153) // 绘制文字
      context.fillText('报价', 340, 153) // 绘制文字
      context.fillText('仓库', 460, 153) // 绘制文字
      // 绘制表格内容
      context.font = 'normal 14px Arial' // 文字字号
      context.fillStyle = '#666666' // 文字颜色
      context.textAlign = 'center'
      for (let i = 0; i < num; i++) {
        let list = this.canvasData
        // 阶梯价取最小值
        const priceList = list[i].priceList
        if (list[i].priceType === 'JTJ') {
          this.$set(list[i], 'price', priceList.find(item => item.tag === 'MIN').unitPrice)
        } else if (list[i].priceType === 'YKJ') {
          this.$set(list[i], 'price', priceList[0].unitPrice)
        }
        const curBrand = list[i].attrList.find(item => item.attrCode === 'brand')
        const curPrice = list[i].priceType === 'DX' ? '电询' : `${this.$utils.thousandMark(list[i].price)}元/${list[i].unitName}` + (list[i].priceType === 'JTJ' ? '起' : '')

        context.fillText(list[i].varietyName || '_', 44, 202 + i * 48) // 绘制文字
        context.fillText(curBrand ? curBrand.v : '_', 135, 202 + i * 48) // 绘制文字
        context.fillText(list[i].times || '_', 245, 202 + i * 48) // 绘制文字
        context.fillText(curPrice || '_', 355, 202 + i * 48) // 绘制文字
        context.textAlign = 'left'
        context.fillText(list[i].pickupWarehouseName || '_', 465, 202 + i * 48) // 绘制文字
        context.textAlign = 'center'
      }

      // 绘制底部信息
      context.font = 'normal 14px Arial' // 文字字号
      context.textAlign = 'left'
      // 先将数组分成一半 用于每行两个联系方式
      const centerIndex = (this.contactList.length - 1) / 2
      const leftContactList = this.contactList.filter((item, index) => index <= centerIndex)
      const rightContactList = this.contactList.filter((item, index) => index > centerIndex)
      // 由于下载的图片文字模糊 这里绘制一个矩形包围解决该问题
      context.beginPath()
      context.rect(0, 180 + num * 48, 910, (leftContactList.length + 1) * 48)
      context.fillStyle = '#ffffff'
      context.fill()
      context.fillStyle = '#333333'
      context.fillText('数量和报价会随时调整，订货前请电话确认。', 20, 180 + (num + 1) * 48) // 绘制文字
      context.fillText('联系人：', 20, 170 + (num + 2) * 48) // 绘制文字
      // 绘制联系人列表
      context.fillStyle = '#666666'
      leftContactList.map((item, index) => {
        context.fillText(`${item.remark} ${item.content}`, 80, 170 - index * 10 + (num + 2 + index) * 48) // 绘制文字
      })
      rightContactList.map((item, index) => {
        context.fillText(`${item.remark} ${item.content}`, 320, 170 - index * 10 + (num + 2 + index) * 48) // 绘制文字
      })
      // 二维码文字
      context.fillText('【扫码识别手机店铺】', 720, 224 + (num + 1) * 48) // 绘制文字
      context.fillText('查看最新现货报价', 733, 244 + (num + 1) * 48) // 绘制文字
      // 二维码图片
      const code = document.getElementById('code')
      context.drawImage(code, 750, 140 + (num + 1) * 48, 66, 66)
      context.save()
      this.showLoading = false
    },
    // 将画布生成图片
    createCanvas () {
      // 通过选择器获取canvas元素
      const canvas = document.getElementById('shareCanvas')
      // 使用toDataURL方法将图像转换被base64编码的URL字符串
      const url = canvas.toDataURL('image/png')
      // 生成一个a元素
      const a = document.createElement('a')
      // 创建一个单击事件
      const event = new MouseEvent('click')
      // 将a的download属性设置为默认前缀加时间戳
      a.download = '报价单图片' + Date.parse(new Date())
      // 将生成的URL设置为a.href属性
      a.href = url
      // 触发a的单击事件
      a.dispatchEvent(event)
    },
    // 关闭弹窗
    handleClose () {
      this.$emit('close')
    }
  },

}
</script>

<style lang="scss" scoped>
  .share_canvas{
    border: 1px solid #eaeaea;
    margin: 5px 4px;
  }
  .canvas_img{
    display: none;
  }
  .footer_wrap{
    margin-top: 30px;
  }
</style>
